import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withProducts from './withProducts';
import withProductKey from './withProductKey';
import { updateProductCustomisation, removeProductCustomisation } from 'src/client/js/store/actions/product';
import { getProductCustomisation } from 'src/client/js/store/selectors/product';

const withProductCustomisation = compose(
  withProducts,
  withProductKey,
  connect(
    (state) => ({
      productCustomisation: getProductCustomisation(state),
    }),
    (dispatch, props) => ({
      updateProductCustomisation: customisation => {
        return dispatch(updateProductCustomisation(props.productKey, customisation));
      },
      removeProductCustomisation: keys => dispatch(removeProductCustomisation(keys))
    }),
  ),
);

export default withProductCustomisation;
